import { FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { RICH_TAGS } from './richTags'

export interface FormattedRichMessageProps {
  id: string
  values?: object
}

export const FormattedRichMessage: FC<FormattedRichMessageProps> = ({ id, values }) => {
  return <FormattedMessage id={id} values={{ ...RICH_TAGS, ...values }} />
}

export default FormattedRichMessage
